import * as yup from 'yup';

import { NAMES } from './FullNameInputs.constants';

export const schema = yup.object().shape({
  [NAMES.FIRSTNAME]: yup.string().required('Введите имя'),
  [NAMES.LASTNAME]: yup.string().required('Введите фамилию'),
});
